// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".connection-status[data-v-9f9eea40]{border:1px solid;border-radius:3px;padding:1px 7px;color:#df5b30}.connection-status.connected[data-v-9f9eea40]{color:#75eb3c}.dialog[data-v-9f9eea40]{position:relative;background:#2b2b30;border-radius:10px;padding:24px}.dialog .close-modal[data-v-9f9eea40]{position:absolute;top:12px;right:12px}@media (min-width:600px){.dialog[data-v-9f9eea40]{padding:64px}}", ""]);
// Exports
module.exports = exports;
